import Api from "../api";
class ProviderApiService {
  addProviderCredentials = async (data = [], provider_id = null) => {
    const { body } = await Api.post(
      `providers/api/credentials/${provider_id}`,
      data
    );
    return body;
  };
  applyCroneJob = async (data = {}) => {
    const { body } = await Api.post(`providers/api/cronejob`, data);
    return body;
  };
  getProviderCredentials = async (provider_id = null) => {
    const { body } = await Api.get(`providers/api/credentials/${provider_id}`);
    return body;
  };

  fetchProvidersAoiDetails = async (
    params = { order_by: "id", order_direction: "ASC" }
  ) => {
    const { body } = await Api.get(`providers/api/apiinfo`, null, params);
    return body;
  };

  fetchProvidersAoiDetailsById = async (id = null) => {
    const { body } = await Api.get(`providers/api/apiinfo/${id}`);
    return body;
  };

  deleteProviderCredentials = async (provider_id = null) => {
    const { body } = await Api.destroy(
      `advertiser/api/credential/${provider_id}`
    );
    return body;
  };

  addProviderCredentialsV2 = async (data = [], provider_id = null) => {
    const { body } = await Api.post(
      `advertiser/api/store-credential/${provider_id}`,
      data
    );
    return body;
  };
  apiStatus = async (data = [], provider_id = null) => {
    const { body } = await Api.post(
      `advertiser/api/status/${provider_id}`,
      data
    );
    return body;
  };

  getProviderCredentialsV2 = async (provider_id = null) => {
    const { body } = await Api.get(
      `advertiser/api/get-credential/${provider_id}`
    );
    return body;
  };
}
// eslint-disable-next-line
export default new ProviderApiService();
